<template>
  <div>
    <div id="email_stats_charts"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "EmailStatsChart",
  data: () => {
    return {};
  },
  props: {},
  components: {},
  computed: {
    ...mapState(["campaign"]),
    v1: function() {
      return (
        "Delivered (" +
        this.$store.state.campaign.campaign_report.CampaignHeader.quantity +
        ")"
      );
    },
    v2: function() {
      return (
        "Opened (" +
        this.$store.state.campaign.campaign_report.CampaignHeader.opens +
        ")"
      );
    },
    v3: function() {
      return (
        "Clicked (" +
        this.$store.state.campaign.campaign_report.CampaignHeader.clicks +
        ")"
      );
    }
  },
  mounted() {
    var options = {
      series: [
        this.$store.state.campaign.campaign_report.CampaignHeader.quantity,
        this.$store.state.campaign.campaign_report.CampaignHeader.opens,
        this.$store.state.campaign.campaign_report.CampaignHeader.clicks
      ],
      chart: {
        type: "pie",
        height: 300
      },
      dataLabels: {
        enabled: false,
        formatter: function(val) {
          return val; // Simply return the raw value
        }
      },
      labels: [this.v1, this.v2, this.v3],
      title: {
        text: "Email Statistics",
        align: "right"
      },
      legend: {
        position: "bottom",
        fontSize: "16px",
        fontWeight: 500
      },
      colors: ["#e23e25DE", "#36454fDE", "#F0DC36DE", "#ADADADDE"]
    };

    var chart = new ApexCharts(
      document.querySelector("#email_stats_charts"),
      options
    );

    chart.render();
  }
};
</script>

<style lang="scss" scoped></style>
